var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3259 12.0001L23.7254 1.60046C24.0915 1.23432 24.0915 0.640699 23.7254 0.274605C23.3593 -0.0914882 22.7656 -0.0915351 22.3995 0.274605L12 10.6742L1.60046 0.274605C1.23432 -0.0915351 0.640697 -0.0915351 0.274605 0.274605C-0.091488 0.640746 -0.0915349 1.23437 0.274605 1.60046L10.6741 12L0.274605 22.3996C-0.0915349 22.7657 -0.0915349 23.3594 0.274605 23.7255C0.457651 23.9085 0.697603 24 0.937556 24C1.17751 24 1.41741 23.9085 1.60051 23.7255L12 13.3259L22.3995 23.7255C22.5825 23.9085 22.8225 24 23.0624 24C23.3024 24 23.5423 23.9085 23.7254 23.7255C24.0915 23.3593 24.0915 22.7657 23.7254 22.3996L13.3259 12.0001Z",
    fill: "#D4AF37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.03e8318b.svg";
export { ForwardRef as ReactComponent };